<div class="card">
    <div class="card-body">
        <h5 class="card-title">Tìm kiếm role</h5>
        <form [formGroup]="searchForm">
            <div class="row">
                <div class="col">
                    <app-input-text label="Mã" placeholder="Nhập mã" [formGroup]="searchForm" formControlName="codeLike"></app-input-text>
                </div>
                <div class="col">
                    <app-input-text label="Tên" placeholder="Nhập tên" [formGroup]="searchForm" formControlName="nameLike"></app-input-text>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-input-select label="Trạng thái" placeholder="Chọn trạng thái" [formGroup]="searchForm" formControlName="status" [optionList]="roleStatusOptionList"></app-input-select>
                </div>
                <div class="col">
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-center">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" (click)="searchRole()" [disabled]="loading"><span *ngIf="loading"  class="spinner-border spinner-border-sm"></span>Tìm kiếm</button>
        </div>
    </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <h5 class="card-title">Kết quả tìm kiếm</h5>
        <div class="alert alert-danger" role="alert" *ngIf="error">
          {{error}}
        </div>
        <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Mã</th>
                    <th scope="col">Tên</th>
                    <th scope="col">Trạng thái</th>
                    <th scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-primary" *ngIf="hasEditPerm" (click)="insertRole()">Thêm</button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="sysRoleList && !loading">
                <tr *ngFor="let sysRole of sysRoleList;index as sysRoleIndex">
                    <td scope="col">{{(sysRolePagination.currentPage-1)*sysRolePagination.pageSize + sysRoleIndex+1}}</td>
                    <td scope="col">{{sysRole.code}}</td>
                    <td scope="col">{{sysRole.name}}</td>
                    <td scope="col">{{roleStatusOptionMap[sysRole.status]}}</td>
                    <td scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-info" (click)="viewRole(sysRole)">Xem</button>
                            <button type="button" class="btn btn-primary" *ngIf="hasEditPerm" (click)="editRole(sysRole)">Sửa</button>
                            <button type="button" class="btn btn-danger"  *ngIf="hasEditPerm" (click)="deleteRole(sysRole)">Xóa</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <div class="d-flex justify-content-between align-items-center" *ngIf="sysRolePagination.pageCount>1 && !loading">
            <nav>
                <ul class="pagination">
                    <li class="page-item" [ngClass]="{'disabled':sysRolePagination.currentPage == 1}">
                      <a class="page-link" (click)="sysRolePageChange(sysRolePagination.currentPage-1)">Trước</a>
                    </li>
                    <li class="page-item" *ngIf="sysRolePagination.currentPage > 3">
                      <a class="page-link" (click)="sysRolePageChange(1)">1</a>
                    </li>
                  <li class="page-item disabled" *ngIf="sysRolePagination.currentPage > 3">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngFor="let page of sysRolePagination.pageList"  [ngClass]="{'active':sysRolePagination.currentPage == page}">
                    <a class="page-link" (click)="sysRolePageChange(page)">{{page}}</a>
                  </li>
                  <li class="page-item disabled" *ngIf="sysRolePagination.currentPage < sysRolePagination.pageCount - 2">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngIf="sysRolePagination.currentPage < sysRolePagination.pageCount - 2">
                    <a class="page-link" (click)="sysRolePageChange(sysRolePagination.pageCount)">{{sysRolePagination.pageCount}}</a>
                  </li>
                  <li class="page-item" [ngClass]="{'disabled':sysRolePagination.currentPage == sysRolePagination.pageCount}">
                    <a class="page-link"  (click)="sysRolePageChange(sysRolePagination.currentPage+1)">Sau</a>
                  </li>
                </ul>
              </nav>
        </div>
    </div>
</div>

